import ModalResumo from '../components/ModalResumo'
import PdfModel from '../components/PdfModel'
import acessos from '../mixins/acessos'
import CardFundacao from '../components/CardFundacao'
import { URLS } from '../constants/urls'

const { FormatREALVirgula, api, FormatREAL } = GLOBAL

export default {
	mixins: [acessos],

	data() {
		return {
			atendimentos: [],
			haveModalResumo: true,
			filter_az: '',
			abaNomeAz: '',
			usuario_responsavel: '',
			todos_clientes: window.global_clientes?.todos_clientes,
		}
	},
	components: {
		ModalResumo,
		CardFundacao,
		PdfModel,
	},

	methods: {
		patrimonioFormated(patrimonio) {
			if (patrimonio == '-') return patrimonio
			if (patrimonio == '0') return '-'
			const value = FormatREALVirgula(patrimonio)
			return value
		},

		politicaFormated(politica) {
			const porc = parseFloat(politica.replace(',', '.')) * 100
			return porc.toFixed(0)
		},

		getAtendimentos() {
			console.log('Hello darknees my old friend.')
			window.location.reload()
		},

		getAtendimentosQuentes() {
			console.log('Hello darknees my old friend.')
		},

		reloadFilter(fundo, nome) {
			let filtersOBJ = GLOBAL.splitFilters(window.location.search) || {}
			filtersOBJ['az'] = fundo
			filtersOBJ['usuario_responsavel'] = this.usuario_responsavel
			filtersOBJ['nome_aba'] = nome
			this.abaNomeAz = nome

			const newFilters = GLOBAL.generateStringFilterFromObject({
				...filtersOBJ,
			})
			// debugger
			window.location.href = `/clientes/todos_clientes_fundacao/${newFilters}`
		},

		openModal({ currentTarget }) {
			const id = currentTarget.getAttribute('data-id')
			const politica = currentTarget.getAttribute('data-politica')

			this.$refs.modalResumo.OpenModalResumo({
				id,
				politica,
				atendimentoID: 0,
			})
		},

		sendNewProspect() {
			console.log('Hello darknees my old friend.')
		},

		openFeedback() {
			document.querySelector('.modal_padrao').classList.add('!min-h-max')
		},

		async handleFilter() {
			console.log('lidar com filtro')
		},
		/**
		 * Recarrega a página trazendo dados do usuario selecionado.
		 * Chamada no mounted.
		 */
		changeSelectFundacao() {
			setTimeout(() => {
				const select = document.querySelector('#fundacao_alterna')

				const urlParams = new URLSearchParams(window.location.search)
				const usuario_responsavel = urlParams.get('usuario_responsavel')

				this.usuario_responsavel = usuario_responsavel

				const inputUserResponsavel = document.querySelector(
					'#usuario_responsavel'
				)
				inputUserResponsavel.value = this.usuario_responsavel

				select?.addEventListener('change', () => {
					const select = document.querySelector('#fundacao_alterna')

					this.usuario_responsavel = select?.value

					inputUserResponsavel.value = this.usuario_responsavel
					this.reloadFilter(this.filter_az)
				})
			}, 100)
		},
		/**
		 * Seta valores dos inputs hidden a cada mudança no select.
		 * Os inputs serão usados para filtrar o intervalo escolhido.
		 * Chamada no mounted.
		 */
		changeSelectPatrimonio() {
			const select = document.querySelector('.patrimonio-select')

			select?.addEventListener('change', () => {
				const inputMin = document.querySelector('[name=patrimonio_min]')
				const inputMax = document.querySelector('[name=patrimonio_max]')
				const values = select?.value.split('-')

				inputMin.value = values[0] || ''
				inputMax.value = values[1] || ''
			})
		},
		/**
		 * Verifica valores dos filtros de patrimônio e seta opçao do select.
		 * Chamada no mounted
		 */
		filterPatrimonio() {
			const select = GLOBAL.getChoicesActive(
				'patrimonio-select',
				window.listOfChoices
			)

			if (!select) return
			const url = new URL(window.location)
			const filters = GLOBAL.splitFilters(url.search)

			if (!filters) return
			let arrFilter = Object.entries(filters)
			let str = ''

			arrFilter.forEach(([chave, valor]) => {
				if (chave == 'patrimonio_min' && valor != '') {
					str += `${valor}`
				}
				if (chave == 'patrimonio_max' && valor != '') {
					str += `-${valor}`
				}
			})
			GLOBAL.setSelectedOptionInChoicesDispatch(select, str)
		},

		clearAllSelects() {
			
			const selects = Array.from(document.querySelectorAll('select'))
			selects.forEach((sel) => {
				try {
					sel.value = ''
					if (typeof sel.selectedIndex !== 'undefined') sel.selectedIndex = -1
					sel.dispatchEvent(new Event('change', { bubbles: true }))
				} catch (e) {}

				
				const choice = GLOBAL.getChoicesActive(sel.id, window.listOfChoices)
				if (choice) {
					GLOBAL.setSelectedOptionInChoicesDispatch(choice, '')
				}
			})

			
			const custom = Array.from(document.querySelectorAll('.patrimonio-select'))
			custom.forEach((el) => {
				try {
					el.value = ''
					el.dispatchEvent(new Event('change', { bubbles: true }))
				} catch (e) {}
				const choice = GLOBAL.getChoicesActive(
					el.id || el.getAttribute('name') || 'patrimonio-select',
					window.listOfChoices
				)
				if (choice) {
					GLOBAL.setSelectedOptionInChoicesDispatch(choice, '')
				}
			})
		},

		/**
		 * Busca todas as fundações de determinado usuário. Chamada em clickChart()
		 * @param {string | number} id - id do usuário selecionado.
		 * @return {array} array de objetos das fundações separadas por categoria.
		 */
		async getDadosGraficoBolhas(id) {
			try {
				const { data: response } = await api.get(
					`${URLS.grafico_bolhas_fundacoes}${id}`
				)

				return response
			} catch (err) {}
		},

		calculaIntervalo(valor) {
			// Os valores negativos ainda estão sendo considerados dentro do intervalo de zero, até saber o que fazer
			if (valor <= 500000000) {
				return 6
			} else if (valor > 500000000 && valor <= 1000000000) {
				return 10
			} else if (valor > 1000000000 && valor <= 5000000000) {
				return 14
			} else if (valor > 5000000000) {
				return 18
			}
		},

		zoomOut(dataLenght) {
			let inicio = 0
			let final = dataLenght
			document
				.querySelector('#chart-bubble')
				.addEventListener('wheel', (event) => {
					event.preventDefault()
					event.stopImmediatePropagation()

					if (event.wheelDeltaY > 0) {
						if (inicio > final) {
							let aux = inicio
							inicio = final
							final = aux
						} else {
							chartBubble.zoomX(inicio, final)
							inicio = inicio + 2 <= final ? inicio + 2 : final
							final = final - 2 >= 0 ? final - 2 : 0
						}
					} else {
						chartBubble.zoomX(inicio, final)
						inicio = inicio - 2 >= 0 ? inicio - 2 : 0
						final = final + 2 > dataLenght ? dataLenght : final + 2
					}
				})
		},

		fillCharts(data, chart, bubble) {
			let colors = ['#55A7FF', '#699CC9', '#437199', '#153047']

			if (chart == chartBubble) {
				let series = [
					{
						name: 'Clientes',
						data: [],
					},
				]
				if (data.length > 0) {
					//solução temporária até encontrar como colocar padding no inicio dos dados
					series[0].data.push({ name: '', x: '', y: 0, z: 0 })
					data.forEach((item, index) => {
						series[0].data.push({
							name: item.sigla,
							x: item.sigla,
							y: item.politica_atendida,
							z: this.calculaIntervalo(Number(item.patrimonio) * 1000),
							fillColor: 'red',
							patrimonio: item.patrimonio,
						})
					})
					//solução temporária até encontrar como colocar padding no fim dos dados
					series[0].data.push({ name: 'fim', x: 'fim', y: 0, z: 0 })
				}

				//alterando a cor conforme valor
				series[0].data.forEach((item) => {
					switch (item.z) {
						case 6:
							item.fillColor = colors[0]
							break
						case 10:
							item.fillColor = colors[1]
							break
						case 14:
							item.fillColor = colors[2]
							break

						case 18:
							item.fillColor = colors[3]
							break
						default:
							break
					}
				})
				const isVazio = series[0].data.length === 0 ? true : false
				const widthChart =
					series[0].data.length - 2 < 30
						? '100%'
						: `${(series[0].data.length - 2) * 40}px`
				chart.updateOptions({
					series,
					chart: {
						//tamanho pra calculado com base em quantidade de clientes
						width: `${isVazio ? '100%' : widthChart}`,
					},
					title: {
						text: ` ${bubble}`,
					},

					tooltip: {
						enabled: true,
						x: {
							show: true,

							formatter: function (valor, { w }) {
								return w.globals.categoryLabels[valor - 1]
							},
						},
						y: {
							formatter: function (valor, { dataPointIndex }) {
								const patrimonio = GLOBAL.FormatREAL(
									series[0].data[dataPointIndex].patrimonio
								)
								return patrimonio || '0,00'
							},
							title: {
								formatter: (seriesName) => 'Patrimônio (Mil):',
							},
						},

						z: {
							formatter: function (valor, y) {
								/* Intervalos considerados
										0 - 500 milhões
										500 - 1 bi
										1 - 5 bi
										acima de 5 bi
									*/
								switch (valor) {
									case 6:
										return `entre R$ ${0} e R$ ${FormatREAL('500000000')}`
									case 10:
										return `entre R$ ${FormatREAL(
											'500000000'
										)} e R$ ${FormatREAL('1000000000')}`
									case 14:
										return `entre R$ ${FormatREAL(
											'1000000000'
										)} e R$ ${FormatREAL('5000000000')}`
									case 18:
										return `acima de R$ ${FormatREAL('5000000000')}`
								}
							},
							title: 'Intervalo:',
						},
					},
				})
			}
		},

		color(bubble) {
			switch (bubble) {
				case 'SAI/Cliente':
					return '#2945D3'
				case 'SAI':
					return '#4D82E9'

				case 'N/A':
					return '#6d6f71'

				case 'Consultor/Gestor':
					return '#079F69'
				default:
					return ''
			}
		},

		removeBorder(divs, bubble) {
			divs.forEach((item) => {
				if (item.getAttribute('bubble') != bubble) {
					item.classList.remove(
						`border-bubble-${item.getAttribute('bubble').split('/').join('-')}`
					)
				}
			})
		},

		positionArrow(svgs, bubble) {
			svgs.forEach((item) => {
				if (item.getAttribute('bubble') != bubble) {
					item.style.transform = 'rotate(0)'
					item.style.transition = '.2s ease opacity, .2s ease transform'
				}
			})
		},

		clickChart() {
			const divs = document.querySelectorAll('.card-bubble')
			const svgs = document.querySelectorAll('.arrow-bubble')
			const divChart = document.querySelector('#bubble')
			divs?.forEach((i) => {
				i.addEventListener('click', async () => {
					const bubble = i.getAttribute('bubble')
					const strBubble = bubble.split('/').join('-')
					//altera cor das bordas dos cards
					i.classList.toggle(`border-bubble-${strBubble}`)
					this.removeBorder(divs, bubble)
					this.positionArrow(svgs, bubble)

					//adiciona borda a div do gráfico
					divChart.style.borderColor = this.color(bubble)

					const svg = document.querySelector(`.arrow_click-${strBubble}`)
					if (i.classList.contains(`border-bubble-${strBubble}`)) {
						// terminando ainda
						let id
						const select = document.querySelector('[name=fundacao_alterna')

						const choice = GLOBAL.getChoicesActive(
							select.id,
							window.listOfChoices
						)
						const options = choice._presetChoices
						options.forEach((op) => {
							if (op.selected) {
								const aux = choice._presetOptions
								aux.forEach((i) => {
									if (i.value == op.value) {
										id = i.getAttribute('userId')
									}
								})
							}
						})

						const data = await this.getDadosGraficoBolhas(id)
						this.fillCharts(data[bubble], chartBubble, bubble)
						this.zoomOut(data[bubble].length)

						divChart.classList.remove('invisible')
						svg.style.transform = 'rotate(90deg)'
						svg.style.transition = '.2s ease opacity, .2s ease transform'
					} else {
						divChart.classList.add('invisible')
						svg.style.transform = 'rotate(0)'
						svg.style.transition = '.2s ease opacity, .2s ease transform'
					}
				})
			})
		},
	},
	mounted() {
		setTimeout(() => {
			this.filterPatrimonio()
			GLOBAL.verifyFilter('modelo_negocio', 'modelo_negocio')
			// this.setSelectFundacao()
		}, 1000)

		const urlParams = new URLSearchParams(window.location.search)
		const az = urlParams.get('az')
		const nome_aba = urlParams.get('nome_aba') || 'Geral'

		this.filter_az = az
		this.abaNomeAz = nome_aba
		const abaGeral = Array.from(document.querySelectorAll('.abaFilter')).find(
			(element) => {
				return String(element.getAttribute('name'))?.toLowerCase() === 'geral'
			}
		)
		if (abaGeral && !this.filter_az) {
			this.reloadFilter(abaGeral.getAttribute('id'), nome_aba)
		}
		this.changeSelectPatrimonio()
		this.clickChart()
		this.changeSelectFundacao()

		const usuario_responsavel = urlParams.get('usuario_responsavel')
		this.usuario_responsavel = usuario_responsavel
	},

	delimiters: ['{*', '*}'], //delimitadores pra n conflitar com o django
}
